/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Cyungo 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Burehe": ["Gitandi", "Karambo", "Karengeri", "Kibande", "Kibogora", "Nyagatovu", "Sove"],
  "Marembo": ["Buyaga", "Gahinga", "Kibuye", "Kidomo", "Murambo", "Nganzo", "Rugaragara", "Rusayu"],
  "Rwili": ["Kabanda", "Karambi", "Kirwa", "Kivumu", "Nturo", "Nyabisasa", "Sakara"]
};